import UrlService from '../../../services/UrlService';
import { SUBMIT_GENERATE_REPORT } from '../vehicleDetails';

export const generateMonitoringEtaCustomerReport = (requestData) => ({
  type: SUBMIT_GENERATE_REPORT.START,
  payload: {
    request: {
      method: 'post',
      responseType: 'blob',
      url: UrlService.generateMonitoringEtaCustomerReport(),
      data: requestData,
    },
  },
});
